module.exports = __webpack_public_path__ + "static/media/pov_whole_Icosahedron.599bcd64.png";